export default __webpack_public_path__ + "static/media/landing.21e4c8d0.svg";